import script from "./PersonalInfoStep2.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalInfoStep2.vue?vue&type=script&setup=true&lang=js"

import "./PersonalInfoStep2.vue?vue&type=style&index=0&id=7f155d19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f155d19"]])

export default __exports__